export default __webpack_public_path__ + "static/media/straight_cards_32.6b524e5d.png";